import type { Actress } from "@/lib/types.ts";

interface SpecTableProps {
  actress: Actress;
}

function formatBirthday(birthday: string | null): string {
  if (!birthday) return "-";
  const parts = birthday.split(/[\/\-]/);
  if (parts.length < 3) return birthday;
  return `${parts[0]}年${parseInt(parts[1])}月${parseInt(parts[2])}日`;
}

function formatActiveAge(debut: number | null, latest: number | null): string {
  if (debut == null || latest == null) return "-";
  if (debut === latest) return `${debut}歳`;
  return `${debut}〜${latest}歳`;
}

export function SpecTable({ actress }: SpecTableProps) {
  const rows = [
    { label: "バスト", value: actress.bust > 0 ? `${actress.bust} cm${actress.cupSize ? `（${actress.cupSize}カップ）` : ""}` : "-" },
    { label: "ウエスト", value: actress.waist > 0 ? `${actress.waist} cm` : "-" },
    { label: "ヒップ", value: actress.hip > 0 ? `${actress.hip} cm` : "-" },
    { label: "身長", value: actress.height > 0 ? `${actress.height} cm` : "-" },
    { label: "生年月日", value: actress.birthday ? `${formatBirthday(actress.birthday)}${actress.age > 0 ? `（${actress.age}歳）` : ""}` : "-" },
    { label: "出演年齢", value: formatActiveAge(actress.debutAge, actress.latestActiveAge) },
  ];

  return (
    <div className="w-full rounded-xl overflow-hidden border border-border bg-card">
      <div className="bg-muted px-5 py-3">
        <h3 className="font-[var(--font-secondary)] text-sm font-semibold text-foreground">
          スペック詳細
        </h3>
      </div>
      {rows.map((row, i) => (
        <div
          key={row.label}
          className={`flex px-5 py-3 ${i < rows.length - 1 ? "border-b border-border" : ""}`}
        >
          <span className="w-24 shrink-0 font-[var(--font-secondary)] text-sm text-muted-foreground">
            {row.label}
          </span>
          <span className="font-[var(--font-secondary)] text-sm text-foreground">
            {row.value}
          </span>
        </div>
      ))}
    </div>
  );
}
